// frontend/smartdocs-admin/src/components/chat/ChatMessage.tsx
import React from 'react';
import MarkdownIt from 'markdown-it';
import type { ChatMessage as ChatMessageType } from '@/components/chat/store/chatStore';

interface ChatMessageProps {
  message: ChatMessageType;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const isUser = message.sender === 'user';
  const isRTL = message.direction === 'rtl';
  const isResponseTime = message.isResponseTime;

  // Initialize the markdown-it parser
  const md = new MarkdownIt();

  // Convert the Markdown to HTML
  const htmlBlock = md.render(message.text);

  return (
    <div className={`flex mb-4 ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`max-w-3/4 px-4 py-2 rounded-lg shadow-md ${isUser
          ? 'bg-blue-500 text-white rounded-br-none'
          : 'bg-gray-200 text-gray-800 rounded-bl-none'
        }`}
      >
        {/* Changed <pre> to <pr> and applied Tailwind CSS classes to mimic pre-formatted text behavior */}
        <div className={`${isRTL ? 'text-right' : 'text-left'}`} dir={`${isRTL ? 'rtl' : 'ltr'}`}>
          <div
            className={`prose  max-w-none ${isUser ? 'prose-white' : ''}`}
            dangerouslySetInnerHTML={{ __html: htmlBlock }}
          />
        </div>
        <div className={`text-sm  ${isResponseTime ? 'block' : 'hidden'}`}>
          <span><br/>{message.responseTime}</span>
        </div>
        <span className={`text-xs mt-1 block  ${isUser ? 'text-blue-200' : 'text-gray-500'}`}>
          {message.timestamp}
        </span>
      </div>
    </div>
  );
};

export default ChatMessage;
